module.exports = __webpack_public_path__ + "media/application/images/logo-boningtonloans-b5afe15b395d3cec5b1d3437a5bed421.png";